import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY, EstimatedUnbillFigureEntity } from "domain/entity/EstimatedUnbillFigure/EstimatedUnbillFigureEntity";
import { EstimatedUnbillFigureRepository } from "domain/repository/EstimatedUnbillFigure/EstimatedUnbillFigureRepo";
import { createEstimatedUnbillFigureValidationSchema } from "presentation/constant/EstimatedUnbillFigure/EstimatedUnbillFigureValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { EstimatedUnbillFigureModel } from "presentation/model/EstimatedUnbillFigure/EstimatedUnbillFigureModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface EstimatedUnbillFigureVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<EstimatedUnbillFigureModel>> | ((value: SetStateAction<EstimatedUnbillFigureModel>) => void),
    ],
    repo: EstimatedUnbillFigureRepository
}

export const EstimatedUnbillFigureVM = ({ dispatch, repo
}: EstimatedUnbillFigureVMProps) => {
    const [estimatedUnbillFigureDispatch] = dispatch;

    const loadDropdownOption = async () => {

    }

    const searchAllEstimatedUnbillFigureList = async () => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
                editingEntity: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                tableList: [],
            }
        })
        repo.searchAllEstimatedUnbillFigureList().then(data => {
            if (data) {
                estimatedUnbillFigureDispatch(prevState => {
                    return {
                        ...prevState,
                        tableList: data,
                    }
                })
            } else {
                estimatedUnbillFigureDispatch(prevState => {
                    return {
                        ...prevState,
                        tableList: [],
                    }
                })
            }
        })
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        estimatedUnbillFigureDispatch(prevState => {
            if (fieldKey === 'year') {
                if (!val.match(/^\d*$/)) {
                    val = prevState.editingEntity.year;
                }
            } else if (fieldKey === 'month') {
                if (!val.match(/^\d*$/)) {
                    val = prevState.editingEntity.month;
                }
            } else if (fieldKey === 'amount') {
                if (!val.match(/^\d*\.{0,1}\d{0,2}$/)) {
                    val = prevState.editingEntity.amount;
                }
            }
            return {
                ...prevState,
                editingEntity: {
                    ...prevState.editingEntity,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: '',
                    }
                }
            }
        })
    }

    const onRowDoubleClick = async (entity: EstimatedUnbillFigureEntity) => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                editingEntity: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onCloseEidtPanel = async () => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                editingEntity: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentRow: EstimatedUnbillFigureEntity) => {
        const valResult = await Validation(createEstimatedUnbillFigureValidationSchema).ValidateFormOnly(currentRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            estimatedUnbillFigureDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return repo.onSave(currentRow);
    }

    const onSaveClicked = () => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onAddClick = async () => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                editingEntity: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
                isAdd: true,
                isShowEditPanel: true,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                editingEntity: isAdd ? { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY } : prevState.currentRow,
            }
        })
    }
    const onEditClick = async () => {
        estimatedUnbillFigureDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    return {
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onAddClick: onAddClick,
        onSave: onSave,
        onSaveClicked: onSaveClicked,
        onCloseEidtPanel: onCloseEidtPanel,
        onRowDoubleClick: onRowDoubleClick,
        onFieldChange: onFieldChange,
        loadDropdownOption: loadDropdownOption,
        searchAllEstimatedUnbillFigureList: searchAllEstimatedUnbillFigureList,
    }
}